import ApolloClient from 'apollo-client';

import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import config, { isFrontOffice } from './config';

const createClient = () => {
  const endpointDomain = isFrontOffice()
    ? config('internalApiDomain', 'https://api.dev.awstrp.net')
    : config('externalApiDomain', 'https://api.dev.troweprice.com');
  const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        'X-TRP-Requested-With': 'XMLHttpRequest',
        apikey: config('apiKey')
      }
    });
    return forward(operation);
  });

  // @todo APIS should have same path
  const path = `/investment-vehicle-svc/service/graphql`;

  const uri = `${endpointDomain}${path}`;
  const httpLink = ApolloLink.from([authMiddleware, new HttpLink({ uri })]);

  /* eslint-disable */
  const cache = new InMemoryCache({
    dataIdFromObject: o => (o._id ? `${o.__typename}:${o._id}` : null)
  });

  return new ApolloClient({
    link: HttpLink.from([httpLink, { credentials: 'include' }]),
    cache
  });
};

export default createClient;
